// src/slices/authSlice.js
import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    id: localStorage.getItem("auth_id") || null,
    isAuthenticated: false,
    loading: true,
    mobileNumber: null,
  },
  reducers: {
    setId: (state, action) => {
      state.id = action.payload;
    },
    setUserId: (state, action) => {
      state.user_id = action.payload;
    },
    setStudentId: (state, action) => {
      state.student_id = action.payload;
    },
    setAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload;
      state.loading = false;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setAccessToken: (state, action) => {
      state.access_token = action.payload;
    },
    setMobileNumber: (state, action) => {
      state.mobileNumber = action.payload;
    },
    setCurrentClassid: (state, action) => {
      state.currentClassId = action.payload;
    },
    setCurrentClassCoachingId: (state, action) => {
      state.currentClassCoachingId = action.payload;
    },
    setCurrentCoachingLogo: (state, action) => {
      state.currentCoachingLogo = action.payload;
    },
    setCurrentCoachingName: (state, action) => {
      state.currentCoachingName = action.payload;
    },
    setUserLocation: (state, action) => {
      const { latitude, longitude, address, name } = action.payload;
      state.userLocation = {
        latitude,
        longitude,
        address: address || "Current Location",
        name: name || null,
      };
    },

    logout: (state) => {
      state.id = null;
      state.isAuthenticated = false;
      state.loading = true; // Set back to true to indicate the app needs to check the authentication state again.
      state.mobileNumber = null;
      state.access_token = null;
      state.user_token = null;
      state.student_id = null;
      state.currentClassId = null;
      state.currentClassCoachingId = null;
      state.userLocation = null;
    },
  },
});

export const {
  setId,
  setAuthenticated,
  logout,
  setUserId,
  setAccessToken,
  setMobileNumber,
  setLoading,
  setStudentId,
  setCurrentClassid,
  setCurrentClassCoachingId,
  setCurrentCoachingLogo,
  setCurrentCoachingName,
  setUserLocation,
} = authSlice.actions;
export default authSlice.reducer;
